import RichTextInput from "ra-input-rich-text";
import React from "react";
import {
	BooleanInput,
	CheckboxGroupInput,
	FormTab,
	maxLength,
	NumberInput,
	ReferenceArrayInput,
	ReferenceInput,
	required,
	SelectInput,
	TabbedForm,
	TextInput,
	useTranslate,
} from "react-admin";
import CodeInput from "../components/inputs/CodeInput";
import { formatMany, parseMany } from "../utils/parsing";
import * as Validation from "../utils/validation";
import {
	BookmakerImportsListField,
	ChannelsListField,
	DealsListField,
	LandingsListField,
} from "./fields/list-fields";
import AdvancedInput from "./inputs/AdvancedInput";
import BcInput from "./inputs/BcInput";
import ImageInput from "./inputs/ImageInput";
import statuses from "./statuses";
import visibilities from "./visibilities";

const optionalUrl = () => (value) => {
	if (!value || value.length === 0) return undefined;
	let valid = Validation.url(value);
	return valid === true ? undefined : valid;
};

const optionalJson = () => (value) => {
	let valid = Validation.json(value || "{}");
	return valid === true ? undefined : valid;
};

const Form = ({ toolbar, create = false, ...props }) => {
	const translate = useTranslate();
	const raToolbar = toolbar ? { toolbar } : {};
	return (
		<TabbedForm {...raToolbar} {...props}>
			<FormTab label={translate("resources.bookmakers.tabs.general")}>
				<SelectInput source="status" choices={statuses} />
				<TextInput source="code" validate={[required(), maxLength(50)]} />
				<SelectInput
					source="visibility"
					choices={visibilities}
					validate={required()}
					helperText={translate("resources.bookmakers.fields.visibility.help")}
				/>
				<TextInput
					source="name"
					fullWidth
					validate={[required(), maxLength(50)]}
				/>
				<ReferenceInput
					source="bookmaker_type_id"
					reference="bookmaker-types"
					validate={required()}
				>
					<SelectInput optionText="name" />
				</ReferenceInput>
				<ReferenceArrayInput
					source="groups"
					reference="groups"
					parse={parseMany}
					format={formatMany}
				>
					<CheckboxGroupInput optionText="name" />
				</ReferenceArrayInput>
				<BooleanInput source="is_approval_required" />
				<TextInput
					source="homepage_url"
					validate={[optionalUrl(), maxLength(200)]}
					fullWidth
				/>
				<ImageInput source="logo" />
				<ReferenceInput
					source="language_id"
					reference="languages"
					validate={required()}
					filter={{ is_nation: true }}
				>
					<SelectInput optionText="name" />
				</ReferenceInput>
				<RichTextInput source="description" multline fullWidth />
			</FormTab>
			<FormTab label={translate("resources.bookmakers.tabs.bonus_comparator")}>
				<BcInput />
			</FormTab>
			<FormTab label={translate("resources.bookmakers.tabs.advanced")}>
				<AdvancedInput create={create} />
			</FormTab>
			<FormTab label={translate("resources.bookmakers.tabs.channels")}>
				<NumberInput source="sync_channels_to_create" />
				<CodeInput
					source="sync_channel_config"
					type="json"
					fullWidth
					className=""
					validate={[optionalJson()]}
					defaultValue={"{}"}
					{...props}
				/>
				{props?.record?.id && <ChannelsListField />}
			</FormTab>
			{props?.record?.id && (
				<FormTab label={translate("resources.bookmakers.tabs.landings")}>
					<LandingsListField />
				</FormTab>
			)}
			{props?.record?.id && (
				<FormTab label={translate("resources.bookmakers.tabs.deals")}>
					<DealsListField />
				</FormTab>
			)}
			{props?.record?.id && (
				<FormTab
					label={translate("resources.bookmakers.tabs.bookmaker_imports")}
				>
					<BookmakerImportsListField />
				</FormTab>
			)}
		</TabbedForm>
	);
};
export default Form;
